<template>
  <v-expansion-panel>
    <v-expansion-panel-header v-slot="{ open }">
      <v-row no-gutters>
        <v-col cols="4" class="blue--text text--darken-1"> Bon de Retour </v-col>
        <v-col cols="8" class="text--secondary">
          <v-fade-transition leave-absolute>
            <span v-if="open" key="0"> Editer le bon puis sauvegarder </span>
            <span v-else key="1">
              <div v-if="bonRetour.account">
                {{ bonRetour.account.name }}
              </div>
              <div v-if="bonRetour.laverie">/ {{ bonRetour.laverie.name }}</div>
            </span>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonRetour.account"
            :items="accounts"
            :item-text="'name'"
            return-object
            label="Siège"
            @update:model-value="onAccountChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le compte siège
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.account" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonRetour.laverie"
            :items="laveries"
            :item-text="'name'"
            return-object
            label="Laverie"
            @update:model-value="onLaverieChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la laverie
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-checkbox
            v-for="(p, index) in products"
            :key="index"
            v-model="selectedProducts"
            :label="`${p.productType} : ${p.aquaNb}`"
            :value="p"
          ></v-checkbox>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> <br />Selectionnez les produits à enlever </v-col>
      </v-row>
      <v-row v-if="bonRetour.laverie && bonRetour.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-text-field
            name="numero"
            hint="Le numéro dans la rue"
            v-model="bonRetour.laverie.address.numero"
            class="input-group--focused"
            label="Numero"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-text-field
            name="rue"
            hint="Le nom de la rue"
            v-model="bonRetour.laverie.address.rue"
            class="input-group--focused"
            label="Rue"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez l'adresse si nécessaire
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.laverie && bonRetour.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-text-field
            name="codepostale"
            hint="Le code postale de la ville"
            v-model="bonRetour.laverie.address.codepostale"
            class="input-group--focused"
            label="Code Postale"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-text-field
            name="ville"
            hint="Le nom de la ville"
            v-model="bonRetour.laverie.address.ville"
            class="input-group--focused"
            label="Ville"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonRetour.laverie && bonRetour.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            name="etage"
            v-model="bonRetour.accessibility.etage"
            class="input-group--focused"
            label="Etage"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="ascenseur"
            v-model="bonRetour.accessibility.ascenseur"
            class="input-group--focused"
            label="Ascenseur"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="escalier"
            v-model="bonRetour.accessibility.escalier"
            class="input-group--focused"
            label="Escalier"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Détaillez l'accessibilité
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.laverie && bonRetour.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            name="codePorte"
            v-model="bonRetour.laverie.codeAcces"
            class="input-group--focused"
            label="Code Porte"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="parkingPrive"
            v-model="bonRetour.accessibility.parking"
            class="input-group--focused"
            label="Parking Privé"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="cle"
            v-model="bonRetour.accessibility.key"
            class="input-group--focused"
            label="Clé"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonRetour.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-menu
            :close-on-content-click="true"
            v-model="rdvDateMenu"
            transition="v-scale-transition"
            offset-y
            :nudge-left="40"
            max-width="290px"
          >
            <template v-slot:activator="{ props }">
              <v-text-field
                v-bind="props"
                label="Rendez-vous"
                v-model="bonRetour.pickupDate"
                prepend-icon="mdi-calendar"
                readonly
                @blur="onBlur"
              ></v-text-field>
            </template>
            <v-date-picker v-model="bonRetour.pickupDate" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date d'enlèvement
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.pickupDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="gestionnaire"
            hint="Nom et prénom du gestionnaire"
            v-model="bonRetour.laverie.gestionnaire"
            class="input-group--focused"
            label="Gestionnaire"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez le gestionnaire si nécessaire
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.pickupDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="gestionnaireMobile"
            hint="Mobile du gestionnaire"
            v-model="bonRetour.laverie.telephonePrincipal"
            class="input-group--focused"
            label="Mobile"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="gestionnaireTel"
            hint="Téléphone du gestionnaire"
            v-model="bonRetour.laverie.telephoneAutre"
            class="input-group--focused"
            label="Téléphone"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonRetour.pickupDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="contactSecondPrenom"
            hint="Nom et prénom du contact secondaire"
            v-model="bonRetour.contactSecond.name"
            class="input-group--focused"
            label="Autre contact"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez un contact secondaire
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.pickupDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="contactSecondTel"
            hint="Téléphone du contact secondaire"
            v-model="bonRetour.contactSecond.telephone"
            class="input-group--focused"
            label="Téléphone"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="contactSecondMobile"
            hint="Mobile du contact secondaire"
            v-model="bonRetour.contactSecond.mobile"
            class="input-group--focused"
            label="Mobile"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonRetour.pickupDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="contactSecondFonction"
            hint="Fonction technique du contact secondaire"
            v-model="bonRetour.contactSecond.fonction"
            class="input-group--focused"
            label="Fonction"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonRetour.pickupDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonRetour.motifRetour"
            :items="motifRetours"
            label="Motif du retour"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le motif du retour
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.motifRetour" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonRetour.enleverPar"
            :items="enleverPars"
            label="A enlever par"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row
        v-if="bonRetour.enleverPar && bonRetour.enleverPar == enleverParAutre"
        no-gutters
      >
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="enleverParAutre"
            v-model="bonRetour.enleverParText"
            class="input-group--focused"
            label="Précisez"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonRetour.enleverPar" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-menu
            :close-on-content-click="true"
            v-model="retourDateMenu"
            transition="v-scale-transition"
            offset-y
            :nudge-left="40"
            max-width="290px"
          >
            <template v-slot:activator="{ props }">
              <v-text-field
                v-bind="props"
                label="Date retour"
                v-model="bonRetour.receivedDate"
                prepend-icon="mdi-calendar"
                readonly
                @blur="onBlur"
              ></v-text-field>
            </template>
            <v-date-picker v-model="bonRetour.receivedDate" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date de retour atelier
        </v-col>
      </v-row>
      <v-row v-if="bonRetour.receivedDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="bonRetourObservations"
            hint="Observations"
            v-model="bonRetour.observations"
            class="input-group--focused"
            label="Observations"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Notez les observations
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
        <generate-doc-btn
          :filePath="bonRetourTemplatePath"
          :fileName="bonRetourFileName"
          :dataSet="bonRetourGen"
          >Save</generate-doc-btn
        >
      </v-card-actions>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { Accessibility } from "@/types";
import type { User } from "@/types";
import { BonRetour, BonRetourGen, EnleverPar, MotifRetour } from "@/types";
import { flattenBonRetour } from "@/types";
import type { Account } from "@/types";
import type { Laverie } from "@/types";
import { getLaveriesByAccountId } from "@/utils/laverie-api";
import type { Product } from "@/types";
import { getProductsByLaverieId } from "@/utils/product-api";

// Props
interface Props {
  accounts: Account[];
  users: User[];
}

const props = defineProps<Props>();

// Reactive state
const rdvDateMenu = ref(false);
const retourDateMenu = ref(false);
const bonRetour = ref<BonRetour>({
  accessibility: {} as Accessibility,
  contactSecond: {} as User,
  selectedProducts: [],
} as BonRetour);
const bonRetourGen = ref<BonRetourGen>({} as BonRetourGen);
const selectedProducts = ref<Product[]>([]);
const laveries = ref<Laverie[]>([]);
const products = ref<Product[]>([]);

// Computed properties
const enleverParAutre = computed(() => EnleverPar.AUTRE);

const enleverPars = computed(() => Object.values(EnleverPar));

const motifRetours = computed(() => Object.values(MotifRetour));

const bonRetourTemplatePath = computed(() => {
  return "templates/BonRetourTemplate.docx";
});

const bonRetourFileName = computed(() => {
  if (bonRetour.value.laverie) {
    return "BonDeRetour_".concat(bonRetour.value.laverie.name);
  }
  return "BonDeRetour";
});

// Methods
const onAccountChange = async (selectedAccount: Account) => {
  bonRetour.value.account = selectedAccount;
  // Reset selected laverie
  bonRetour.value.laverie = null;
  // Clear previous data
  laveries.value = [];
  await fetchLaveries(selectedAccount.id);
  // Regenerate document data
  bonRetourGen.value = flattenBonRetour(bonRetour.value);
};

const onLaverieChange = async (selectedLaverie: Laverie) => {
  bonRetour.value.laverie = selectedLaverie;
  // Clear previous data
  products.value = [];
  await fetchProducts(selectedLaverie.id);
  // Regenerate document data
  bonRetourGen.value = flattenBonRetour(bonRetour.value);
};

const fetchProducts = async (laverieId: string) => {
  try {
    products.value = await getProductsByLaverieId(laverieId);
  } catch (error) {
    console.error("Error fetching products:", error);
    products.value = [];
  }
};

const fetchLaveries = async (accountId: string) => {
  try {
    laveries.value = await getLaveriesByAccountId(accountId);
  } catch (error) {
    console.error("Error fetching laveries:", error);
    laveries.value = [];
  }
};

const onChange = () => {
  onBlur();
};

const onBlur = () => {
  bonRetour.value.selectedProducts = selectedProducts.value;
  bonRetourGen.value = flattenBonRetour(bonRetour.value);
};

const onCancel = () => {
  // TODO clear form
  bonRetour.value = {
    accessibility: {} as Accessibility,
    contactSecond: {} as User,
    selectedProducts: [],
  } as BonRetour;
  bonRetourGen.value = {} as BonRetourGen;
  selectedProducts.value = [];
  laveries.value = [];
  products.value = [];
};
</script>
